"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serverRender = serverRender;
exports.clientRender = clientRender;
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _server = babelHelpers.interopRequireDefault(require("react-dom/server"));

var _contactInfo = babelHelpers.interopRequireDefault(require("contact-info"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _decorators = require("decorators");

var _class, _temp;

var MainNavigation = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(MainNavigation, _Component);

  function MainNavigation() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, MainNavigation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(MainNavigation)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this.state = {
      navOpened: false
    };
    return _this;
  }

  babelHelpers.createClass(MainNavigation, [{
    key: "navToggle",
    value: function navToggle(event) {
      event.preventDefault();
      this.setState(function (state) {
        return {
          navOpened: !state.navOpened
        };
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      _classList.default[this.state.navOpened ? 'add' : 'remove'](document.body, 'modal-open');
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement("div", {
        className: "main-nav-hamburger"
      }, _react.default.createElement("div", null, _react.default.createElement("img", {
        className: "side-nav-icon",
        src: "/admin/platform/plugins/com.sightworks.5.Channel.instance.marketing/resources/images/menu-button-bare.png",
        onClick: this.navToggle
      }))), _react.default.createElement("div", {
        className: _classList.default.join('side-navigation', 'overlay', this.state.navOpened ? 'expanded-nav' : null),
        id: "myNav"
      }, _react.default.createElement("div", {
        className: "overlay-content"
      }, _react.default.createElement("div", {
        className: "side-nav-main"
      }, _react.default.createElement("div", {
        className: "top-side-nav"
      }, _react.default.createElement("ul", null, _react.default.createElement("li", {
        className: "large-side-nav"
      }, _react.default.createElement("a", {
        href: ""
      }, "Home")), this.props.poolServices.map(function (item, index) {
        return _react.default.createElement("li", {
          className: "large-side-nav",
          key: index
        }, _react.default.createElement("a", {
          href: item.href
        }, item.title));
      }))), _react.default.createElement("ul", null, _react.default.createElement("li", {
        className: "small-side-nav"
      }, _react.default.createElement("a", {
        href: "https://shop.thepoolandspahouse.com/",
        target: "_blank"
      }, "Shop Online")), _react.default.createElement("li", {
        className: "small-side-nav"
      }, _react.default.createElement("a", {
        href: this.props.shop
      }, "Pickup In-Store")), _react.default.createElement("li", {
        className: "small-side-nav"
      }, _react.default.createElement("a", {
        href: this.props.services
      }, "Services")), _react.default.createElement("li", {
        className: "small-side-nav"
      }, _react.default.createElement("a", {
        href: this.props.poolSchools
      }, "Pool Schools")), _react.default.createElement("li", {
        className: "small-side-nav"
      }, _react.default.createElement("a", {
        href: this.props.aboutUs
      }, "About Us")), _react.default.createElement("li", {
        className: "small-side-nav"
      }, _react.default.createElement("a", {
        href: this.props.locations
      }, "Locations")), _react.default.createElement("li", {
        className: "small-side-nav"
      }, _react.default.createElement("a", {
        href: this.props.feedback
      }, "Feedback")), _react.default.createElement("li", {
        className: "small-side-nav"
      }, _react.default.createElement("a", {
        href: "http://prosite.thepoolandspahouse.com",
        target: "_blank"
      }, "Pro Login"))), _react.default.createElement("div", {
        className: "social-links"
      }, this.props.socialLinks.map(function (item, index) {
        return _react.default.createElement("a", {
          key: index,
          href: item.href,
          target: "_blank"
        }, _react.default.createElement("img", {
          src: item.image
        }));
      }))), _react.default.createElement("div", null, _react.default.createElement("img", {
        className: "glyphicon-remove side-nav-remove-icon",
        src: "/admin/platform/plugins/com.sightworks.5.Channel.instance.marketing/resources/images/close-white.png",
        onClick: this.navToggle
      })))));
    }
  }]);
  return MainNavigation;
}(_react.Component), _temp), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "navToggle", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "navToggle"), _class.prototype)), _class);
exports.default = MainNavigation;

function serverRender(page) {
  var props = {
    phoneNumber: page.block("Layouts.MainLayout", 'Default Phone Number').resolve('503-906-8118'),
    poolServices: page.blockFromPage('Home', 'Header - Pool Types').process(function (group) {
      return [].map.call(group.records, function (item) {
        return {
          href: page.getLink('pool-service', item),
          title: item.title
        };
      });
    }),
    shop: page.getLink('shop'),
    services: page.getLink('services'),
    poolSchools: page.getLink('pool-schools'),
    aboutUs: page.getLink('about-us'),
    locations: page.getLink('locations'),
    feedback: page.getLink('feedback'),
    socialLinks: page.block('Layouts.MainLayout', 'Social Links').process(function (group) {
      return [].map.call(group.records, function (item) {
        return {
          href: item.linkURL,
          image: item.image_name
        };
      });
    })
  };
  return "\n\t\t<div data-component='MainNavigation'>".concat(_server.default.renderToString(_react.default.createElement(MainNavigation, props)), "</div>\n\t\t<script>\n\t\t\trequire('navigation-new').clientRender(document.querySelector('[data-component=MainNavigation]'), ").concat(JSON.stringify(props), ");\n\t\t</script>\n\t");
}

function clientRender(node, props) {
  _reactDom.default.render(_react.default.createElement(MainNavigation, props), node);
}